import React from 'react';
import G from "../libs/Glob.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import appLib from "../libs/appLib.mjs";
import {Button, ButtonGroup, ButtonToolbar} from "reactstrap";
import "./ListLibraries.css";
import EditIcon from "../media/images/EditIcon.mjs";
import NewLibrary from "./NewLibrary.mjs";
import libHelper from "../libs/libHelper.mjs";
import TrashIcon from "../media/images/TrashIcon.mjs";
import DuplicateIcon from "../media/images/DuplicateIcon.mjs";
import AddIcon from "../media/images/AddIcon.mjs";
import HamburgerArea from "../controls/HamburgerArea.mjs";
import DownloadIcon from "../media/images/DownloadIcon.mjs";
import UploadIcon from "../media/images/UploadIcon.mjs";
import MyLibraryIcon from "../media/images/MyLibraryIcon.mjs";

const prefix = 'ListLibraries';

const libSorter = (a, b) => (a.getField('code')+a.getName()).toLocaleLowerCase().localeCompare((b.getField('code')+b.getName()).toLocaleLowerCase());

const ListLibraries = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			language: G.getLanguage()
		};
		this.uid = G.generateUid(prefix);
		this.saveNewLibrary  = this.saveNewLibrary.bind(this);
		this.rmLibrary  = this.rmLibrary.bind(this);
		this.getLibraries = this.getLibraries.bind(this);
		this.replaceLibrary = this.replaceLibrary.bind(this);
	}
	componentDidMount() {
		G.setStatus('pageTitle', G.label('Libraries list'));
		G.setStatus('pageButtons' );
		G.register( 'Prefs', () => {
			G.setStatus('pageTitle', G.label('Libraries list'));
			this.setState({language: G.getLanguage()});
		}, this.uid);
		this.getLibraries();
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}
	async getLibraries( libs ) {
		try {
			if ( typeof libs === 'undefined' ) libs = await appLib.listLibraries();
			this.setState({libraries: libs});
		} catch (error) {
			console.error(error);
		}
	}
	/**
	 * @param {import("../libs/LibHelper").AthenaLibHelperObject} orig
	 * @param {import("../../AtenaLibrary").AthenaLibraryDefinitionRootNode } replacement
	 * @return {Promise<void>}
	 */
	async replaceLibrary( orig, replacement) {
		if ( ! replacement?.uuid ) return;
		if ( ! (replacement.uuid && replacement.coverageMax && replacement.maturityAggr ) ) {
			window.alert(G.label('UploadLibraryDefinition'));
			return;
		}
		if ( replacement.enriched ) {
			window.alert(G.label('UploadLibraryDefinitionNotExport'));
			return;
		}
		if ( ! window.confirm(G.label("ConfirmLibraryReplacement")) ) return;
		replacement.uuid = orig.getField('uuid');
		const ns = {};
		appLib.saveLibrary(
			replacement
		).then( (libraries) => {
			if ( libraries ) ns.libraries = libraries;
		}).catch(e => {
			console.error(e);
		}).finally( ()=>{
			this.setState(ns)
		});
	}
	/**
	 * @param {import("../../AtenaLibrary").AthenaLibraryDefinitionRootNode } data
	 * @return {void}
	 */
	saveNewLibrary(data) {
		if ( ! data.children) data.children = [];
		const ns = {newLibrary:false};
		appLib.saveLibrary(
			data
		).then( (libraries) => {
			if ( libraries ) ns.libraries = libraries;
		}).catch(e => {
			console.error(e);
		}).finally( ()=>{
			this.setState(ns)
		});
	}
	rmLibrary( lh ) {
		const n = `“${ lh.getName() }”`;
		if ( ! window.confirm( G.label('RemoveWarning', {item: n}))) return;
		if ( ! window.confirm( G.label('RemoveLastWarning', {item: n}))) return;
		const ns = {newLibrary:false};
		appLib.rmLibrary(
			lh.getField('uuid')
		).then( (libraries) => {
			if ( libraries ) ns.libraries = libraries;
		}).catch(e => {
			console.error(e);
		}).finally( ()=>{
			this.setState(ns)
		});
	}
	render() {
		if ( ! this.state.libraries ) return '';
		return(
			<div className={'app-panel-small ' + prefix} id={this.uid}>
				<h4>
					<MyLibraryIcon />
					<TextLabel value={"Available libraries"} />
				</h4>
				<div className={"panel-content"}>
					<div className={"list-libraries"}>
						{this.state.libraries?.length === 0 ? (
							<h5 align="center">
								<TextLabel value={"NoItemsFound"}/>
							</h5>
						) : (
							<table>
								<thead>
								<tr>
									<th>
										<TextLabel value={"Code"}/>
									</th>
									<th>
										<TextLabel value={"Name"}/>
									</th>
									<th className={"version"}>
										<TextLabel value={"Version"}/>
									</th>
									<th/>
								</tr>
								</thead>
								<tbody>
								{this.state.libraries
									.map(l => (new libHelper(l, this.state.language)) )
									.sort( libSorter )
									.map((l, i) => (
											<tr key={i} className={l.getField('published') ? 'published' : 'unpublished'}>
												<td>
													{l.getField('code')}
												</td>
												<td title={ l.getDesc() }>
													{l.getName()}
												</td>
												<td className={"version"}>
													{l.getField('version').toFixed(2)}
												</td>
												<td className={"icon-button-bar"}>
													<span
														role={"button"}
														title={ G.label('Edit') }
														onClick={ ()=>{
															G.gotoPage({ name: "EditLibrary", params: {id: l.getField("uuid")} });
														}}
													>
														<EditIcon/>
													</span>
													<HamburgerArea align={"end"}>
														<ButtonToolbar style={{flexDirection: "column",rowGap:"8px"}}>
															<ButtonGroup
																vertical={true}
																className={"btn-icon"}
															>
																<Button
																	onClick={ ()=>{
																		G.gotoPage({ name: "EditLibrary", params: {id: l.getField("uuid")} });
																	}}
																>
																	<b>
																		<TextLabel value={"Edit"} />
																	</b>
																	<i>
																		<EditIcon />
																	</i>
																</Button>
																<Button
																	onClick={ async ()=>{
																		appLib.duplicateLibrary(
																			l.getField('uuid')
																		).then( libraries => {
																			this.getLibraries( libraries );
																		}).catch(e => {
																			console.error(e);
																		})
																	}}
																	>
																	<b>
																		<TextLabel value={"Duplicate"} />
																	</b>
																	<i>
																		<DuplicateIcon />
																	</i>
																</Button>
															</ButtonGroup>
															<ButtonGroup
																vertical={true}
																className={"btn-icon"}
															>
																<Button
																	onClick={ async () => {
																		G.saveJSON(
																			await appLib.getLibrary(l.getField("uuid")),
																			l.getField("uuid")+'.json'
																		)
																	}}
																>
																	<b>
																		<TextLabel value={"Download"} />
																	</b>
																	<i>
																		<DownloadIcon />
																	</i>
																</Button>
																<Button
																	onClick={ async () => {
																		const chosen = await G.uploadJSON();
																		if ( chosen ) this.replaceLibrary( l, chosen);
																	}}
																>
																	<b>
																		<TextLabel value={"Upload"} />
																	</b>
																	<i>
																		<UploadIcon />
																	</i>
																</Button>
																<Button
																	onClick={ async () => {
																		G.saveJSON(
																			await appLib.getEnriched(l.getField("uuid")),
																			'exported-'+l.getField("uuid")+'.json'
																		)
																	}}
																>
																	<b>
																		<TextLabel value={"Export"} />
																	</b>
																	<i>
																		<DownloadIcon />
																	</i>
																</Button>
															</ButtonGroup>
															<ButtonGroup
																vertical={true}
																className={"btn-icon"}
															>
																<Button
																	color={"danger"}
																	onClick={() => { this.rmLibrary(l) }}
																>
																	<b>
																		<TextLabel value={"Delete"} />
																	</b>
																	<i>
																		<TrashIcon />
																	</i>
																</Button>
															</ButtonGroup>
														</ButtonToolbar>
													</HamburgerArea>
												</td>
											</tr>
										)
									)}
								</tbody>
							</table>
						)}
					</div>
					<hr/>
					<div className={"new-library"}>
						<ButtonGroup
							className={"btn-icon"}
						>

							<Button
								title={ G.label('UploadLibraryDefinition') }
								onClick={ async ()=>{
									const lib = await G.uploadJSON();
									if ( ! lib ) return;
									this.saveNewLibrary(lib);
								}}
							>
								<i>
									<UploadIcon />
								</i>
								<b>
									<TextLabel value={"Upload library"} />
								</b>
							</Button>
							<Button
								className={"btn-icon"}
								onClick={() => {
									this.setState({newLibrary: true})
								}}
							>
								<b>
									<TextLabel value={"New library"}/>
								</b>
								<i>
									<AddIcon/>
								</i>
							</Button>
						</ButtonGroup>
					</div>
				</div>
				{this.state.newLibrary && (
					<NewLibrary
						save={ d => this.saveNewLibrary(d) }
						cancel={ ()=>{ this.setState({newLibrary:false}) }}
					/>
				)}
			</div>
		);
	}
}

export default ListLibraries;
